export default "__VITE_ASSET__DrWUOWxJ__"